import { useTranslation } from 'react-i18next'
import { notification } from 'antd'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { useAuth } from '@/middlewares/auth/auth-context'

export const STATUS_KEYS = ['event', 'ticketing', 'planning', 'leaderboard', 'volunteering']

/**
 * The four publish mutations of the Status block (same calls as the former EventHubSettingsBar and
 * MyCompetitions' PublishInputs). `onChange(key, state)` runs on success so the shell (and the hub,
 * through the shell context) mirror the new value. `volunteering` stays a read flag only (William,
 * 14 Oct 2026): the volunteer settings derive it from the application dates.
 */
export default function useOrgStatusToggles(event, onChange) {
    const { t } = useTranslation(TranslationNS.EVENT_PAGE)
    const authContext = useAuth()

    const publishRequest = async (key, path, state) => {
        try {
            await authContext.sendRequest('put', path, { state }, () => {
                onChange?.(key, state)
                notification.success({ message: t('Saved successfully') })
            })
        } catch (error) {
            console.error('/useOrgStatusToggles publishRequest - error', error)
            notification.error({ message: t('Oops, an error occurred !') })
        }
    }

    const id = event?._id
    return {
        event: (state) => publishRequest('event', `event/publish/${id}`, state),
        ticketing: (state) => publishRequest('ticketing', `ticketing/publish/${id}`, state),
        planning: (state) => publishRequest('planning', `planning/publish/${id}`, state),
        leaderboard: (state) =>
            publishRequest('leaderboard', `leaderboard/competition/${id}/leaderboard/publish`, state),
    }
}
